export function convertToURI(element: string, type: string = "image/svg_xml") {
	return `data:${type},${encodeURI(element)}`;
}
